import { gql } from '@utils/gpl-dedup';
import { userFragment } from '@graphql/users/fragments';

export const onCallAssignmentFragment = gql`
  fragment onCallAssignmentFragment on OnCallAssignment {
    from_day
    to_day
    from_time
    to_time
    primary {
      id
      ...user
    }
    secondary {
      id
      ...user
    }
  }
  ${userFragment}
`;
